/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:20
 * @LastEditTime: 2019-10-22 17:18:55
 * @LastEditors: Please set LastEditors
 */
import axios from 'axios';
import qs from 'qs';
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器

axios.interceptors.request.use(
    config => {
        config.data = qs.stringify(config.data);
        config.headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                'accept': 'application/json',
            }
            // localStorage.setItem('access_tokens', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjgxOWY0ZDYzYjVmNWQzOWM5NmUyMGE4NDcwNzI0ZDFjMTQzMTQzZmU5MWUwMjg3Yjc4MGUzZjBhZmY1ZDkzZWI2MjMyNGIxZTUzZDJkYjNiIn0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6IjgxOWY0ZDYzYjVmNWQzOWM5NmUyMGE4NDcwNzI0ZDFjMTQzMTQzZmU5MWUwMjg3Yjc4MGUzZjBhZmY1ZDkzZWI2MjMyNGIxZTUzZDJkYjNiIiwiaWF0IjoxNzE3NDcxODI2LCJuYmYiOjE3MTc0NzE4MjYsImV4cCI6MTcxODc2NzgyNiwic3ViIjoiMTM5Iiwic2NvcGVzIjpbIioiXX0.RyBKIh5S2I-1z3rizuBLqWYUGfjZ28uQCi-nEKZef5gXugr2TGw_XbI5Va9n8x0x_BTXP7FHCgzGKsarPM-yE7W00Atq85ntzKUaSepCqmArV2mexdC5-3tfGdiW8xHUiTlehktFFQFepiHRYunGXTDatG1e9inxFrjsD4d7V2Zm6bo8oIRt1-sdu477GB07wqbHn9UCvKX0XZ2uB3XoCEgV2TDAM_dPzM0rFGGueF5BT5qGMe3ONM8zen2i1HWHkJNWl0JghzozVguI4TEAJd0q_O-Nzl33tOt23ukxy_Hg--jCsYN_9x78l_rEqmmzWDA6vd84p1R-PpZkunObTzb6zu1yPkLhtngRj582b-Kp60YiLPFEceqdpiTcXhE9pLW_P_IWqmAVclpkAzIMtJoMZd4lrUrsnIGXBRaRLpbuSAvtAJQg8FkxcmFo6YvZ3NTY_lWX-lxeuZggAMC_eBSQuBJwjagxXLzCvfCDPdGizSwWEHvi3uj1yUFFbtJ7_rplZ4dhU1A2aXhNyEq4jCS-QLYH8vYxWSJ_aqsmcPjB8UmNqxb4qKxQYcF5LVa1WWjXLbUFelRP01_-Q4lAtvnK-QCaiaIMrhGCkMcoDpcAfvn6XMJQEdWsmS2wdvdXO475RTJ_n_ZkKwXWtHpvbl8DMflc4iDMieBDxiiH1T8')
        config.headers.Authorization = 'Bearer' + " " + localStorage.getItem('access_tokens')
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
//http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code == 100) {
            location.href = location.href.split('#/')[0] + '#/login'; //跳回登陆页面
        }
        return response;
    },
    error => {
        if(error.data){
           return Promise.reject(error.data)
        }else{
            return Promise.reject(error.response.data)
        }
    }
)

//定义全局的api
let api;

if(process.env.VUE_APP_type == 'development'){
    api = {
        // logistics:'https://logistics.c.smartcode.vip/admin/v2',
        // logistics_2:'https://pps.c.smartcode.vip/index.php/',
        // pda : 'https://logistics.c.smartcode.vip/pda/v2/',
        logistics:'https://logistics.smartcode.vip/admin/v2',
        logistics_2:'https://pps.smartcode.vip/index.php/',
        pda : 'https://logistics.smartcode.vip/pda/v2/',
    }
}else if(process.env.VUE_APP_type == 'production'){
    api = {
        logistics:'https://logistics.smartcode.vip/admin/v2',
        logistics_2:'https://pps.smartcode.vip/index.php/',
        pda : 'https://logistics.smartcode.vip/pda/v2/',
    }
}else if(process.env.VUE_APP_type == 'person'){
    api = {
        logistics:'https://logistics.tx315.vip/admin/v2',
        logistics_2:'http://pps.tx315.vip/index.php/',
        pda : 'https://logistics.tx315.vip/pda/v2/',
    }
}else  if(process.env.VUE_APP_type=='zd'){
    api = {
        logistics:'https://logistics.cn2de.com/admin/v2',
        logistics_2:'https://pps.cn2de.com/index.php/',
        pda : 'https://logistics.cn2de.vip/pda/v2/',

    }
 }else  if(process.env.VUE_APP_type=='hd'){
    api = {
        logistics:'https://qyhb-logistics.haid.com.cn/admin/v2',
        logistics_2:'https://qyhb-pps.haid.com.cn/index.php/',
        pda : 'https://qyhb-logistics.haid.com.cn/pda/v2/',
    }
 }else  if(process.env.VUE_APP_type=='ym'){
    api = {
        logistics:'https://logistics.ymbiaoshi.cn/admin/v2',
        logistics_2:'https://pps.ymbiaoshi.cn/index.php/',
        pda: 'https://logistics.ymbiaoshi.cn/pda/v2/',
    }
 }

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(module, url, params = {}) {
    let baseUrl = '';
    if (module == "logistics") {
        baseUrl = api.logistics + url;
    } else if (module == "logistics_2") {
        baseUrl = api.logistics_2 + url;
    } else if (module == "pda") {
        baseUrl = api.pda + url;
    }
    return new Promise((resolve, reject) => {
        axios.get(baseUrl, {
                params: params
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(module, url, data = {}) {
    if (module == "logistics") {
        url = api.logistics + url;
    } else if (module == "logistics_2") {
        url = api.logistics_2 + url;
    } else if (module == "pda") {
        url = api.pda + url;
    }
    return new Promise((resolve, reject) => {
        axios.post(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(module, url, data = {}) {
    if (module == "logistics") {
        url = api.logistics + url;
    } else if (module == "logistics_2") {
        url = api.logistics_2 + url;
    } else if (module == "pda") {
        url = api.pda + url;
    }
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(module, url, data = {}) {
    if (module == "logistics") {
        url = api.logistics + url;
    } else if (module == "logistics_2") {
        url = api.logistics_2 + url;
    } else if (module == "pda") {
        url = api.pda + url;
    }
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(module, url, data = {}) {
    if (module == "logistics") {
        url = api.logistics + url;
    } else if (module == "logistics_2") {
        url = api.logistics_2 + url;
    } else if (module == "pda") {
        url = api.pda + url;
    }
    return new Promise((resolve, reject) => {
        axios.delete(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}